import classNames from 'classnames';

export default function (chunk, nextChunk, classes) {
  // Is this the first chunk in a chunk group?
  if (
    !chunk.get('group_with_last') &&
    nextChunk &&
    nextChunk.get('group_with_last')
  ) {
    var firstInGroup = true;
  }

  // Is this the last chunk in a chunk group?
  if (
    chunk.get('group_with_last') &&
    (!nextChunk || !nextChunk.get('group_with_last'))
  ) {
    var lastInGroup = true;
  }

  return classNames(classes, {
    grouped: chunk.get('group_with_last') || firstInGroup || lastInGroup,
    last: lastInGroup,
    first: firstInGroup,
  });
}
